import {Component, OnInit, ViewChild} from '@angular/core';
import {DataObjEditComponent, DataObjEditComponentHelper, Select2Data} from '../../rest-service';
import {Department, DepartmentService} from '../../department.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NotificationService} from '../../notification.service';
import {UserService} from '../../user.service';
import {Observable} from 'rxjs/Observable';
import {SelectComponent} from 'ng2-select';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-department-edit',
  templateUrl: './department-edit.component.html',
  styleUrls: ['./department-edit.component.css']
})
export class DepartmentEditComponent implements OnInit, DataObjEditComponent<Department> {

  // name of the object in the singular
  readonly vowelSingular = 'o Departamento';

  readonly entityPath = '/departments';

  departments: Department[];

  parents: Select2Data[] = [];

  @ViewChild('select') selectParent: SelectComponent;

  helper: DataObjEditComponentHelper<Department>;

  readonly defaultObj = new Department(null, '', null, null, false, null);

  controlsConfigs = [{
    'description': ['', Validators.required],
    'parentId': ['']
  }];

  validationMessages = [
    {
      'description': {
        'required': 'Descrição não informada'
      }
    }
  ];

  constructor(private fb: FormBuilder, public router: Router, public route: ActivatedRoute, public ns: NotificationService,
              public service: DepartmentService, public us: UserService) {
    this.helper = new DataObjEditComponentHelper(fb, this.controlsConfigs, this.validationMessages, this.entityPath,
      this.router, this.ns, this.service, this);
  }

  ngOnInit() {
    this.helper.buildForm();
    this.selectParent.active = [];
    this.route.params.switchMap((params: Params) => {
      const id = params['id'];
      return this.processId(id);
    }).subscribe((obj: Department) => {
      this.helper.actualObj = obj;
      this.refreshParents(obj);
    });
    this.helper.formGroups.forEach((formGroup, index, array) =>
      formGroup.valueChanges.debounceTime(250).subscribe((data) => this.helper.onValueChanges(data, index)));
  }

  processId(id: string) {
    if (id && id !== '') {
      this.helper.editing = true;
      return this.service.getById(id);
    } else {
      this.helper.editing = false;
      return Observable.of(this.defaultObj);
    }
  }

  validateFields(index: number, defaultFormErrors: any): Observable<any> {
    if (index === 0) {
      const description = this.helper.formGroups[0].get('description').value;
      let parentId = null;
      if (!isNullOrUndefined(this.selectParent.active[0])) {
        parentId = this.selectParent.active[0].id;
      }
      console.log(`Description: ${description} parentId: ${parentId}`);
      if (!isNullOrUndefined(description) && description !== '' && !this.helper.editing) {
        return this.service.countByCustomerIdAndDescriptionAndParentId(this.us.currentUser.getValue().customerDatabaseId,
          description, parentId)
          .map((value) => {
            if (value !== 0) {
              console.log(`Department description already used by ${value} departments in the same parent...`);
              if (isNullOrUndefined(defaultFormErrors['description'])) {
                defaultFormErrors['description'] = new Array<string>();
              }
              defaultFormErrors['description'].push('Descrição de departamento já utilizada neste nível');
              this.helper.formInvalid[index] = true;
            }
            return defaultFormErrors;
          });
      } else {
        return Observable.of(defaultFormErrors);
      }
    }
    // return Observable.of(defaultFormErrors);
  }

  trySave(index: number, model: any) {
    this.helper.preSave();
    console.log(`Trying to save: ${JSON.stringify(model)}`);
    this.helper.isAllValid(index).subscribe((valid) => {
      if (valid) {
        const obj = this.fromModel(model);
        this.helper.decideOperation(obj).subscribe((res) => {
          this.helper.processResult(index, res);
          this.helper.formGroups.forEach((formGroup, idx, array) =>
            formGroup.valueChanges.debounceTime(250).subscribe((data) => this.helper.onValueChanges(data, idx)));
          if (this.helper.editing) {
            this.refreshParents(obj);
          } else {
            this.refreshParents(this.defaultObj);
          }
        }, (error) => {
          console.log(`Error Saving object: '${obj}': ${JSON.stringify(error)}`);
          this.ns.error(error.toString(), 'Erro ao salvar');
        }, () => {
          this.helper.postSave();
        });
      } else {
        console.log(`NotSaving because something is invalid...`);
        this.helper.postSave();
      }
    }, (error) => {
      this.ns.error(error.toString(), 'Erro ao salvar');
    });
  }

  fromModel(model: any): Department {
    let id = null;
    if (this.helper.editing) {
      id = this.helper.actualObj.id;
    }
    let parentId = null;
    if (!isNullOrUndefined(this.selectParent.active[0])) {
      parentId = this.selectParent.active[0].id;
    }
    return new Department(id, model.description, parentId, this.us.currentUser.getValue().customerDatabaseId,
      false, null);
  }

  toModel(obj: Department, fg: FormGroup) {
    fg.controls['description'].patchValue(obj.description);
    fg.controls['parentId'].patchValue(obj.parentId);
    if (!isNullOrUndefined(obj.parentId)) {
      console.log(`Searching parent id: ${obj.parentId}`);
      const selected = this.parents.find((department) => department.id === obj.parentId);
      console.log(`Setting parent id to ${JSON.stringify(selected)}`);
      this.selectParent.active = [selected];
    }
  }

  setDepartment(data: any) {
    this.helper.formGroups[0].controls['parentId'].patchValue(data.id);
  }

  refreshParents(obj: Department) {
    this.service.getAllByCustomerId(this.us.currentUser.getValue().customerDatabaseId).subscribe((res) => {
      this.departments = res;
      this.parents = DepartmentService.getDepartmentsSelectData(this.departments, obj.id);
      console.log(`Got ${this.parents.length} Parents:`);
      // this.parents.forEach(dep => console.log(JSON.stringify(dep)));
      this.toModel(obj, this.helper.formGroups[0]);
    });
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/department/department-edit/department-edit.component.ts